import { render } from "./QuestionFifteen.vue?vue&type=template&id=a6c5db08"
import script from "./QuestionFifteen.vue?vue&type=script&lang=js"
export * from "./QuestionFifteen.vue?vue&type=script&lang=js"

import "./QuestionFifteen.vue?vue&type=style&index=0&id=a6c5db08&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__